<template>
  <sp-icon slot="prepend" class="insurance-status-icon" :name="model.icon"></sp-icon>
  <template v-if="model.isAccepted">{{ acceptedLabel }}</template>
  <template v-else-if="model.isNotAccepted">Offers Self-Pay Options</template>
  <template v-else-if="model.isNoProviderData">May Accept Your Insurance</template>

  <sp-tooltip slot="append">
    <sp-icon class="tooltip-activator" name="help-filled"></sp-icon>

    <div slot="content">
      <WideLayoutContent :model="model" />
    </div>
  </sp-tooltip>
</template>

<script setup>
import WideLayoutContent from "./WideLayoutContent.ce.vue";

defineProps({
  model: {
    type: Object,
    required: true,
  },
  acceptedLabel: {
    type: String,
    default: "Accepts Your Insurance",
  },
});
</script>

<style lang="scss">
:host {
  --sp-ce-slot-display: block;
}
</style>

<style lang="scss" scoped>
.tooltip-activator {
  --size: 22px;
  --fill: var(--sp-sys-color-link);
  margin-left: 0.25rem;
}

.insurance-status-icon {
  --size: var(--sp-comp-insurance-app-status-icon-size, var(--alert-prepend-icon-size, 1em));
}
</style>
